import * as React from 'react';
import PropTypes from 'prop-types';

import TagsCard from './tags_card';
import TagsApi from './tags_api';
import { map, values } from 'lodash';

class Tags extends React.Component {
  static propTypes = {
    canManageTags: PropTypes.bool,
    classSlug: PropTypes.string.isRequired,
    isNewRecord: PropTypes.bool,
    paths: PropTypes.shape({
      tags: PropTypes.string.isRequired
    }).isRequired,
    tagIds: PropTypes.object,
    tags: PropTypes.array.isRequired,
    onAddTag: PropTypes.func,
    onRemoveTag: PropTypes.func
  };

  state = {
    tags: this.props.tags
  };

  handleRemove = (tag) => {
    const { isNewRecord, onRemoveTag, paths } = this.props;

    if (isNewRecord) {
      onRemoveTag(tag);
    } else {
      const api = new TagsApi(paths);
      api.deleteTag(tag).then((newTags) => {
        this.setTags(newTags);
      });
    }
  };

  handleAdd = (tag) => {
    const { isNewRecord, onAddTag, paths } = this.props;
    const api = new TagsApi(paths);

    if (isNewRecord) {
      api.createTag(tag).then((tag) => {
        onAddTag(tag);
      });
    } else {
      api.saveTag(tag).then((tags) => {
        this.setTags(tags);
      });
    }
  };

  setTags = (tags) => {
    this.setState({ tags });
  };

  render() {
    const { canManageTags, isNewRecord, paths } = this.props;
    const { tags } = this.state;

    return (
      <React.Fragment>
        <TagsCard
          editable={canManageTags}
          paths={paths}
          tags={isNewRecord ? this.props.tags : tags}
          onAdd={this.handleAdd}
          onRemove={this.handleRemove}
        />
        {this.renderHiddenTagField()}
      </React.Fragment>
    );
  }

  renderHiddenTagField = () => {
    const { classSlug, isNewRecord, tagIds } = this.props;

    if (isNewRecord) {
      return map(values(tagIds), tagId => (
        <input
          id={`${classSlug}_tag_ids`}
          name={`${classSlug}[tag_ids][]`}
          type="hidden"
          value={tagId}
        />
      ));
    }
  };
}

export default Tags;
